import "../css/MobilePage.css";

const MobilePage = () => {
    return (
        <div className="page--ctn mobilePage">
            <h1 className="mobilePage--text">View on a larger display for better experience</h1>
        </div>
    );
}

export default MobilePage;
